import React from 'react';
import { CardBody } from 'reactstrap';
import './NumberOfBlogs.css'

const NumberOfBlogsCardBody = () => {
    return (
        <CardBody className="card-body pt-0">
            <div className="right-side icon-right-success">
                {/* <i className="fa fa-shopping-basket"></i> */}
                <i className="fa fa-user"></i>
                <div className="shap-block">
                    <div className="rounded-shap animate-bg-secondary">
                        <i></i>
                        <i></i>
                    </div>
                </div>
            </div>
        </CardBody>
    );
};

export default NumberOfBlogsCardBody;
